// Şantiye Günlüğü Mock Data
// Görevlerim (kişisel planlama) + Günlük Raporlar (müteahhite bilgilendirme)

const today = new Date();
const formatDate = (d) => d.toISOString().split('T')[0];
const daysAgo = (n) => { const d = new Date(today); d.setDate(d.getDate() - n); return formatDate(d); };
const daysLater = (n) => { const d = new Date(today); d.setDate(d.getDate() + n); return formatDate(d); };

// ==========================================
// 1. GÖREVLER — Şefin kişisel yapılacaklar listesi
// ==========================================

export const oncelikler = [
    { key: 'acil', label: 'Acil', color: 'error' },
    { key: 'normal', label: 'Normal', color: 'warning' },
    { key: 'dusuk', label: 'Düşük', color: 'info' },
];

export const kategoriler = [
    { key: 'malzeme', label: 'Malzeme', color: 'bg-info' },
    { key: 'isgucu', label: 'İş Gücü', color: 'bg-secondary' },
    { key: 'ekipman', label: 'Ekipman', color: 'bg-tertiary' },
    { key: 'genel', label: 'Genel', color: 'bg-primary' },
];

export const gorevler = [
    // Bugün
    { id: 'g-001', metin: 'Beton pompası kiralama firmasını ara', tarih: daysAgo(0), oncelik: 'acil', kategori: 'ekipman', tamamlandi: false, insaatId: 'c-001', sefId: 'sef-1' },
    { id: 'g-002', metin: '3. kat demir teslimatını takip et', tarih: daysAgo(0), oncelik: 'acil', kategori: 'malzeme', tamamlandi: false, insaatId: 'c-001', sefId: 'sef-1' },
    { id: 'g-003', metin: 'Kalıpçı ekibiyle yarının programını görüş', tarih: daysAgo(0), oncelik: 'normal', kategori: 'isgucu', tamamlandi: true, insaatId: 'c-001', sefId: 'sef-1' },
    { id: 'g-004', metin: 'İş güvenliği bariyerlerini kontrol et', tarih: daysAgo(0), oncelik: 'normal', kategori: 'genel', tamamlandi: false, insaatId: 'c-001', sefId: 'sef-1' },
    { id: 'g-005', metin: 'Elektrik tesisatçısına çağrı yap', tarih: daysAgo(0), oncelik: 'dusuk', kategori: 'isgucu', tamamlandi: true, insaatId: 'c-001', sefId: 'sef-1' },
    // Yarın
    { id: 'g-006', metin: 'A Blok 4. kat kalıp kurulumu başlat', tarih: daysLater(1), oncelik: 'acil', kategori: 'genel', tamamlandi: false, insaatId: 'c-001', sefId: 'sef-1' },
    { id: 'g-007', metin: 'Çimento silosu dolum kontrolü', tarih: daysLater(1), oncelik: 'normal', kategori: 'malzeme', tamamlandi: false, insaatId: 'c-001', sefId: 'sef-1' },
    { id: 'g-008', metin: 'Vinç operatörü ile yük planı yap', tarih: daysLater(1), oncelik: 'normal', kategori: 'ekipman', tamamlandi: false, insaatId: 'c-001', sefId: 'sef-1' },
    // Dün (tamamlananlar)
    { id: 'g-009', metin: 'Hafriyat kamyonlarını organize et', tarih: daysAgo(1), oncelik: 'acil', kategori: 'ekipman', tamamlandi: true, insaatId: 'c-001', sefId: 'sef-1' },
    { id: 'g-010', metin: 'B Blok temel kalıp söküm', tarih: daysAgo(1), oncelik: 'normal', kategori: 'genel', tamamlandi: true, insaatId: 'c-001', sefId: 'sef-1' },
    { id: 'g-011', metin: 'Su tesisatı malzemesi teslim al', tarih: daysAgo(1), oncelik: 'normal', kategori: 'malzeme', tamamlandi: true, insaatId: 'c-001', sefId: 'sef-1' },
    // Bu hafta (ileriki günler)
    { id: 'g-012', metin: 'Belediye ruhsat evraklarını tamamla', tarih: daysLater(3), oncelik: 'acil', kategori: 'genel', tamamlandi: false, insaatId: 'c-001', sefId: 'sef-1' },
    { id: 'g-013', metin: 'İzolasyon malzemesi sipariş ver', tarih: daysLater(4), oncelik: 'normal', kategori: 'malzeme', tamamlandi: false, insaatId: 'c-001', sefId: 'sef-1' },
];

// ==========================================
// 2. SAHA RAPORLARI — Müteahhite bilgilendirme
// ==========================================

export const havaDurumlari = [
    { key: 'gunesli', label: 'Güneşli' },
    { key: 'parcali_bulutlu', label: 'Parçalı Bulutlu' },
    { key: 'bulutlu', label: 'Bulutlu' },
    { key: 'yagmurlu', label: 'Yağmurlu' },
    { key: 'karli', label: 'Karlı' },
];

export const sahaRaporlari = [
    {
        id: 'sr-001',
        tarih: daysAgo(0),
        hava: 'gunesli',
        personelSayisi: 24,
        ozet: 'A Blok 3. kat kalıp işleri tamamlandı, beton dökümüne hazır. B Blok demir bağlama işleri devam ediyor.',
        yapilanIsler: [
            'A Blok 3. kat kalıpları tamamlandı',
            'B Blok 2. kat demir bağlama devam',
            'Elektrik tesisat boruları döşendi',
        ],
        sorunlar: ['Beton pompası arızası — 2 saat gecikme'],
        yarinPlani: 'Sabah 06:00 beton dökümü başlayacak. B Blok demir tamamlanacak.',
        kaydeden: 'Ahmet Yılmaz',
        sefId: 'sef-1',
        insaatId: 'c-001',
        createdAt: `${daysAgo(0)}T17:45:00Z`,
        photoUrls: [
            'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=400&fit=crop',
            'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=400&fit=crop',
            'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop',
        ],
        photoCount: 3,
    },
    {
        id: 'sr-002',
        tarih: daysAgo(1),
        hava: 'parcali_bulutlu',
        personelSayisi: 22,
        ozet: 'Demir bağlama ve kalıp hazırlık işleri sorunsuz tamamlandı.',
        yapilanIsler: [
            'A Blok 3. kat demir döşeme tamamlandı',
            'Kalıp malzemeleri 4. kata taşındı',
            'Tesisat boruları kontrol edildi',
        ],
        sorunlar: [],
        yarinPlani: 'Kalıp kurulumu ve beton hazırlığı yapılacak.',
        kaydeden: 'Ahmet Yılmaz',
        sefId: 'sef-1',
        insaatId: 'c-001',
        createdAt: `${daysAgo(1)}T17:15:00Z`,
        photoUrls: [],
        photoCount: 0,
    },
    {
        id: 'sr-003',
        tarih: daysAgo(2),
        hava: 'yagmurlu',
        personelSayisi: 12,
        ozet: 'Yağmur nedeniyle yarım gün çalışıldı. Sadece iç mekan işleri yapıldı.',
        yapilanIsler: [
            'İç mekanlarda demir bağlama',
            'Malzeme düzenlemesi ve stok sayımı',
        ],
        sorunlar: ['Yağmur nedeniyle dış cephe işleri durdu', 'Şantiye yolları çamurlandı'],
        yarinPlani: 'Hava açacak, geciken dış cephe işlerine ağırlık verilecek.',
        kaydeden: 'Mehmet Kaya',
        sefId: 'sef-2',
        insaatId: 'c-001',
        createdAt: `${daysAgo(2)}T15:30:00Z`,
        photoUrls: [
            'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=400&fit=crop',
        ],
        photoCount: 1,
    },
    {
        id: 'sr-004',
        tarih: daysAgo(3),
        hava: 'gunesli',
        personelSayisi: 28,
        ozet: 'Temel kazı %100 tamamlandı. Hafriyat çıkışı sorunsuz yapıldı.',
        yapilanIsler: [
            'Temel kazısı tamamlandı',
            'Hafriyat kamyonları sahadan çıktı',
            'Kalıp malzemeleri sahaya alındı',
            'Zemin etüdü sonuçları kontrol edildi',
        ],
        sorunlar: [],
        yarinPlani: 'Kalıp hazırlıklarına başlanacak.',
        kaydeden: 'Ahmet Yılmaz',
        sefId: 'sef-1',
        insaatId: 'c-001',
        createdAt: `${daysAgo(3)}T18:10:00Z`,
        photoUrls: [
            'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=400&h=400&fit=crop',
            'https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?w=400&h=400&fit=crop',
            'https://images.unsplash.com/photo-1536895058696-a69b1c7ba34f?w=400&h=400&fit=crop',
            'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=400&fit=crop',
            'https://images.unsplash.com/photo-1429775309822-ca0e4b2e0a10?w=400&h=400&fit=crop',
        ],
        photoCount: 5,
    },
];

// Mock şef listesi (admin filtresi için)
export const santiyeSefleri = [
    { id: 'sef-1', name: 'Ahmet Yılmaz', insaatId: 'c-001' },
    { id: 'sef-2', name: 'Mehmet Kaya', insaatId: 'c-001' },
];

// ==========================================
// HELPER FONKSİYONLAR
// ==========================================

// Görevler
export const getGorevlerByTarih = (tarih, insaatId) => {
    let data = insaatId
        ? gorevler.filter(g => g.insaatId === insaatId)
        : gorevler;
    if (tarih) data = data.filter(g => g.tarih === tarih);
    return data.sort((a, b) => {
        // Tamamlanmayanlar üste, sonra öncelik sırası
        if (a.tamamlandi !== b.tamamlandi) return a.tamamlandi ? 1 : -1;
        const oncelikSira = { acil: 0, normal: 1, dusuk: 2 };
        return (oncelikSira[a.oncelik] || 1) - (oncelikSira[b.oncelik] || 1);
    });
};

export const getGorevlerByHafta = (insaatId) => {
    const bugun = new Date();
    const haftaBasi = new Date(bugun);
    haftaBasi.setDate(bugun.getDate() - bugun.getDay() + 1); // Pazartesi
    const haftaSonu = new Date(haftaBasi);
    haftaSonu.setDate(haftaBasi.getDate() + 6); // Pazar

    const baslangic = formatDate(haftaBasi);
    const bitis = formatDate(haftaSonu);

    let data = insaatId
        ? gorevler.filter(g => g.insaatId === insaatId)
        : gorevler;

    return data.filter(g => g.tarih >= baslangic && g.tarih <= bitis)
        .sort((a, b) => {
            if (a.tamamlandi !== b.tamamlandi) return a.tamamlandi ? 1 : -1;
            return a.tarih.localeCompare(b.tarih);
        });
};

export const getGorevStats = (insaatId) => {
    const data = insaatId
        ? gorevler.filter(g => g.insaatId === insaatId)
        : gorevler;

    const bugunStr = formatDate(today);
    const bugunGorevleri = data.filter(g => g.tarih === bugunStr);

    return {
        toplamGorev: data.length,
        tamamlanan: data.filter(g => g.tamamlandi).length,
        bekleyen: data.filter(g => !g.tamamlandi).length,
        bugunToplam: bugunGorevleri.length,
        bugunTamamlanan: bugunGorevleri.filter(g => g.tamamlandi).length,
        bugunBekleyen: bugunGorevleri.filter(g => !g.tamamlandi).length,
        acilBekleyen: data.filter(g => !g.tamamlandi && g.oncelik === 'acil').length,
    };
};

// Raporlar
export const getRaporlarByInsaat = (insaatId, sefId) => {
    let data = insaatId
        ? sahaRaporlari.filter(r => r.insaatId === insaatId)
        : sahaRaporlari;
    if (sefId) data = data.filter(r => r.sefId === sefId);
    return data.sort((a, b) => b.tarih.localeCompare(a.tarih));
};

export const getRaporStats = (insaatId) => {
    const data = insaatId
        ? sahaRaporlari.filter(r => r.insaatId === insaatId)
        : sahaRaporlari;

    return {
        toplamRapor: data.length,
        sorunluGunler: data.filter(r => r.sorunlar?.length > 0).length,
        ortPersonel: data.length > 0
            ? Math.round(data.reduce((a, r) => a + r.personelSayisi, 0) / data.length)
            : 0,
    };
};

export const getSeflerByInsaat = (insaatId) => {
    if (!insaatId) return santiyeSefleri;
    return santiyeSefleri.filter(s => s.insaatId === insaatId);
};

// Dashboard uyumluluğu — eski alan adlarını korur
export const getSantiyeGunluguStats = (insaatId) => {
    const stats = getRaporStats(insaatId);
    return {
        toplamKayit: stats.toplamRapor,
        toplamPersonelGun: stats.ortPersonel,
        sorunluGunler: stats.sorunluGunler,
        fotografSayisi: sahaRaporlari
            .filter(r => !insaatId || r.insaatId === insaatId)
            .reduce((sum, r) => sum + (r.photoCount || 0), 0),
    };
};
